import React, { Component } from 'react';
import _ from 'lodash';
import { reduxForm, Field, formValueSelector, getFormMeta, getFormSyncErrors, getFormAsyncErrors } from 'redux-form';
import { connect } from 'react-redux';
import { Form, ListGroup, ListGroupItem } from 'react-bootstrap';
import GeneralDataField from '../../../../components/GeneralDataField/';
import validate from './validate';
import './styles.css';
import asyncValidate from './asyncValidate';
import { lastBlurredField } from '../../../../actions/basket';

class YourSummaryForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.stateData
    };
  }

  editState = (editValue, anyError) => {
    if (anyError || anyError === undefined) {
      const newEditValue = !this.state[editValue + 'Edit'];
      this.setState({ [editValue + 'Edit']: newEditValue, [editValue]: this.props[editValue + 'Value'] });
    }
  };

  renderFields() {
    return _.map(this.props.fieldData, ({ componentProps, component, data, name, required }) => {
      const fieldSyncError = this.props.fieldSyncErrors && this.props.fieldSyncErrors[name];
      const fieldAsyncError = this.props.fieldAsyncError && this.props.fieldAsyncError[name];
      const isActive = this.props.fields && this.props.fields[name] && !!this.props.fields[name].active;

      if (name === 'TransferHeader') {
        return <ListGroupItem key={name} header={this.props.transferHeader} className="form-header-split" />;
      }

      const ifRequired = required ? false : true;

      let selectValue = false;
      if (name.includes('seatType')) {
        selectValue = this.props.transfers.children[name.substring(8)]['seatType']['description'];
      }
      if (this.props.transfers.shuttle.showTo && name.includes('arrivalStop')) {
        selectValue = this.props.transfers.shuttle[name]['name'];
      }
      if (this.props.transfers.shuttle.showFrom && name.includes('departureStop')) {
        selectValue = this.props.transfers.shuttle[name]['name'];
      }
      if (this.props.transfers.shuttle.showTimes && name.includes('busNumber')) {
        selectValue = this.props.transfers.shuttle['bus']['name'];
      }
      if (ifRequired) {
        if (
          !this.state[name + 'Edit'] &&
          this.props.asyncValidating !== name &&
          !!!fieldSyncError &&
          !isActive &&
          !fieldAsyncError
        ) {
          return (
            <GeneralDataField
              key={name}
              {...componentProps}
              data={selectValue || this.props.initialValues[name]}
              handleEditState={this.editState}
              format={(value, name) => (value === '' ? null : value)}
              name={name}
              form={this.props.form}
            />
          );
        } else {
          return (
            <Field
              key={name}
              component={component}
              componentProps={componentProps}
              handleEditState={this.editState}
              name={name}
              ifAutoFocus={this.state[name + 'Edit']}
              onFocus={() => this.props.lastBlurredField(name)}
              disabled={this.props.asyncValidating}
            />
          );
        }
      }
    });
  }

  render() {
    const SubHeader = this.props.subheader;
    const { handleSubmit } = this.props;
    return (
      <div className="transfer-details-wrapper" style={this.props.style}>
        <Form ref="myform" horizontal onSubmit={handleSubmit}>
          <ListGroup>
            <ListGroupItem
              header={this.props.header}
            />
            {this.props.toValue ? <SubHeader to={this.props.toValue} from={this.props.fromValue} /> : null}
            {this.props.fieldData ? this.renderFields() : null}
          </ListGroup>
        </Form>
      </div>
    );
  }
}

YourSummaryForm = reduxForm({
  onSubmit: val => console.log('in form', val),
  validate,
  asyncValidate,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  shouldValidate(params) {
    if (params.nextProps && !params.nextProps.error) {
      if (params.nextProps.activeKey === '3') return true;
    }
    return false;
  }
})(YourSummaryForm);

YourSummaryForm = connect(
  (state, ownProps) => {
    const selector = formValueSelector(ownProps.form);
    const selectorValues = {};
    _.each(ownProps.selectorData, (val, key) => {
      selectorValues[val] = selector(state, key);
    });
    return {
      ...selectorValues,
      fields: getFormMeta(ownProps.form)(state),
      fieldSyncErrors: getFormSyncErrors(ownProps.form)(state),
      lastBlurred: state.basket.lastBlurredField,
      fieldAsyncError: getFormAsyncErrors(ownProps.form)(state)
    };
  },
  { lastBlurredField },
  null,
  { ref: true }
)(YourSummaryForm);

export default YourSummaryForm;



// WEBPACK FOOTER //
// ./src/containers/QuotePage/YourSummaryPanel/form/index.js